import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../store';
import { getImageUrl } from '../services/api';

export const useWhiteLabelTheme = () => {
  const whiteLabelConfig = useSelector((state: RootState) => state.whiteLabel.config);
  const settings = useSelector((state: RootState) => state.settings.settings);

  useEffect(() => {
    if (whiteLabelConfig?.branding_config) {
      const { primary_color, secondary_color } = whiteLabelConfig.branding_config;

      // Apply primary color
      if (primary_color) {
        document.documentElement.style.setProperty('--primary-color', primary_color);
        // Also update common CSS variables
        document.documentElement.style.setProperty('--color-primary', primary_color);
      }

      // Apply secondary color
      if (secondary_color) {
        document.documentElement.style.setProperty('--secondary-color', secondary_color);
        document.documentElement.style.setProperty('--color-secondary', secondary_color);
      }

      // Update document title
      if (whiteLabelConfig.name) {
        document.title = whiteLabelConfig.name;
      }
    }
  }, [whiteLabelConfig]);

  useEffect(() => {
    if (settings?.favicon_url) {
      const link = document.querySelector("link[rel~='icon']") as HTMLLinkElement;
      if (link) link.href = getImageUrl(settings.favicon_url);
    }
  }, [settings?.favicon_url]);

  return whiteLabelConfig;
};
